module.exports = __webpack_public_path__ + "static/media/intro-image.eb2a905b.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Landing/intro-image.png
// module id = 1125
// module chunks = 0